// client/src/dnd/emitter_tool/utils/clamp.js
export const clamp01 = (v) => Math.max(0, Math.min(1, Number(v)));
